<template>
  <Hero />
  <div class="h-1 bg-amber-700"></div>
  <About />
  <Carousel />
  <Venues />
  <Casting />
  <Music />
  <Author />
  <!--Tickets /> <Banner / -->
</template>

<script setup lang="ts">
import DefaultLayout from '~/layouts/DefaultLayout.vue'

definePage({
  name: 'Home',
  meta: {
    layout: DefaultLayout
  }
})
</script>
